import { PenIcon } from "@xola/icons";
import { Label } from "@xola/ui-kit";
import clsx from "clsx";
import { SwitchField } from "common";
import React, { useState } from "react";
import { Affiliate, XolaPartner, XolaPartnerStatus } from "types";
import { useResource } from "../../hooks/useResource";
import { NoTranslate } from "./NoTranslate";
import { PartnerSelectionState, PartnerSelectorModal } from "./PartnerSelectionModal";
import { SecondaryButton } from "./SecondaryButton";
import { useSeller } from "@/hooks/useAccount";
import { useCollection } from "@/hooks/useCollection";

interface SelectedPartnerListInputProps {
    label: string;
    value: PartnerSelectionState;
    onChange: (value: PartnerSelectionState) => void;
    isSelectAll?: boolean;
    error?: string | null;
}

export const SelectedPartnerListInput = ({
    label,
    value,
    onChange,
    isSelectAll,
    error,
}: SelectedPartnerListInputProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div>
            <PartnerSelectorModal
                isOpen={isModalOpen}
                title={label}
                value={value}
                onChange={onChange}
                onClose={() => {
                    setIsModalOpen(false);
                }}
            />

            <div
                className="mb-2 flex items-end justify-between"
                data-testid="selected-agent-list-input-commercial-channels"
            >
                <div>
                    <Label className={clsx("whitespace-nowrap", error && "!text-danger")}>
                        {label} {error}
                    </Label>
                </div>

                <div>
                    {isSelectAll ? (
                        <SwitchField
                            size="small"
                            isChecked={value.agents.all && value.operators.all}
                            onChange={(isChecked) => {
                                onChange({
                                    agents: { all: isChecked, selected: [] },
                                    operators: { all: isChecked, selected: [] },
                                });
                            }}
                        >
                            Select All
                        </SwitchField>
                    ) : null}

                    <SecondaryButton
                        className="ml-4"
                        size="small"
                        disabled={isSelectAll ? value.agents.all && value.operators.all : false}
                        onClick={() => setIsModalOpen(true)}
                    >
                        <PenIcon />
                    </SecondaryButton>
                </div>
            </div>
            <div className="space-y-2">
                <div className="max-h-40 divide-y divide-gray-lighter overflow-y-auto rounded-lg border border-gray-lighter">
                    {value.agents.selected.length > 0 ? (
                        <>
                            <span className="block py-2 px-4">Agents</span>
                            {value.agents.selected.map((id) => (
                                <AgentListItem key={id} id={id} />
                            ))}
                        </>
                    ) : isSelectAll ? null : (
                        <div className="py-3 px-4 text-gray-dark">
                            {value.agents.selected ? "All agents selected" : "No agent selected"}
                        </div>
                    )}
                </div>
                <div className="max-h-40 divide-y divide-gray-lighter overflow-y-auto rounded-lg border border-gray-lighter">
                    {value.operators.selected.length > 0 ? (
                        <>
                            <span className="block py-2 px-4">Operators</span>
                            {value.operators.selected.map((id) => (
                                <OperatorListItem key={id} id={id} />
                            ))}
                        </>
                    ) : isSelectAll ? null : (
                        <div className="py-3 px-4 text-gray-dark">
                            {value.operators.selected ? "All operators selected" : "No operator selected"}
                        </div>
                    )}
                </div>
            </div>
            {/* <div className="space-y-2">
                <div className="max-h-40 divide-y divide-gray-lighter overflow-y-auto rounded-lg border border-gray-lighter">
                    {value.agents.selected.length > 0 ? (
                        <>
                            <span className="block py-2 px-4">Agents</span>
                            {value.agents.selected.map((id) => (
                                <AgentListItem key={id} id={id} />
                            ))}
                        </>
                    ) : isSelectAll ? null : (
                        <div className="py-3 px-4 text-gray-dark">
                            {value.agents.selected ? "All agents selected" : "No agent selected"}
                        </div>
                    )}
                </div>
                <div className="max-h-40 divide-y divide-gray-lighter overflow-y-auto rounded-lg border border-gray-lighter">
                    {value.operators.selected.length > 0 ? (
                        <>
                            <span className="block py-2 px-4">Operators</span>
                            {value.operators.selected.map((id) => (
                                <OperatorListItem key={id} id={id} />
                            ))}
                        </>
                    ) : isSelectAll ? null : (
                        <div className="py-3 px-4 text-gray-dark">
                            {value.operators.selected ? "All operators selected" : "No operator selected"}
                        </div>
                    )}
                </div>
            </div> */}
        </div>
    );
};

const AgentListItem = ({ id }: { id: ID }) => {
    const { data: affiliate } = useResource<Affiliate>(["affiliates", id]);

    return (
        <span className="flex items-center py-2 px-3">
            <NoTranslate className="ml-2 font-bold text-black">{affiliate?.name}</NoTranslate>
        </span>
    );
};

const OperatorListItem = ({ id }: { id: ID }) => {
    const seller = useSeller();
    const { data: operators } = useCollection<XolaPartner>(["partners"], {
        expand: "partnerSeller",
        seller: seller.id,
        partnerSeller: id,
        status: XolaPartnerStatus.ACCEPTED,
        limit: 1,
    });

    const operator = operators?.[0];

    if (!operator) {
        return null;
    }

    return (
        <span className="flex items-center py-2 px-3">
            <NoTranslate className="ml-2 font-bold text-black">{operator.partnerSeller.name}</NoTranslate>
        </span>
    );
};

/**
 * All Selected - show nothing
 * else -> show everything
 *
 *
 */
